import { Component, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { Zone } from 'src/app/models/zone';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexTooltip,
  ApexXAxis,
  ApexLegend,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexStroke
} from "ng-apexcharts";
import { SensorType } from 'src/app/models/sensor';
import { SensorTypes } from 'src/app/constants/SensorTypes';
import { ZoneService } from 'src/app/services/zone.service';

import { DatePipe } from '@angular/common';
import { SensorPipe } from 'src/app/pipes/sensor-display-name.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { Sensor } from '../../models/sensor';
import * as moment from 'moment';


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  markers: any; //ApexMarkers;
  stroke: ApexStroke; //ApexStroke;
  yaxis: ApexYAxis | ApexYAxis[];
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  legend: ApexLegend;
  fill: ApexFill;
  tooltip: ApexTooltip;
  colors: string[];
};

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.less']
})
export class ReportsComponent implements OnInit {
  zoneList: Zone[];
  selectedZone: Zone = {};
  selectedComparedZone: Zone = {};
  selectedTypes: SensorType[];
  selectedComparedTypes: SensorType[];
  selectedRange: any = {};
  selectedComparedRange: any = {};
  dateRangeOption: string = 'none';
  comparedDateRangeOption: string = 'none';
  shouldCompare: boolean = false;
  sensorTypeOptions: SensorType[];
  stateHistoryOptions: any;
  comparedStateHistoryOptions: any;
  selectedState: any;
  selectedComparedState: any;
  isLoading: boolean = false;
  private subscription: Subscription;
  currentCompany: any = null
  zones: Zone[] = [];
  zoomed: boolean = false;
  zoomedIn: any = '';
  zoomedOut: any = '';
  currentReport: any = null;
  startDate: any = null
  endDate: any = null
  currentInverval: any = null

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  public comparedChartOptions: Partial<ChartOptions>;
  constructor(private sanitizer: DomSanitizer, private zoneService: ZoneService, private datePipe: DatePipe, private sensorDisplayName: SensorPipe, private dataService: DataService) {
    this.subscription = this.dataService.sharedCompany$.subscribe(company => {
      this.currentCompany = company;
    })
    if (this.currentCompany && localStorage.getItem('zoneList')) {
      this.zoneList = JSON.parse(localStorage.getItem('zoneList'));
    }
    if (!this.currentCompany){
      this.getZones()
    }
    this.chartOptions = {
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#4caf50', '#4ecdc4', '#f8961e'],
      series: [
      ],
      chart: {
        height: 400,
        type: "line",
        stacked: false,
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true,
          },
        }
      },
      dataLabels: {
        enabled: false
      },
      title: {
        text: this.selectedZone.name || '',
        align: "left",
        offsetX: 110
      },
      tooltip: {
        fixed: {
          enabled: true,
          position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60
        },
        x: {
          format: 'dd/MM/yyyy HH:mm'
        }

      },
      legend: {
        horizontalAlign: "left",
        offsetX: 40
      },
      stroke: {
        curve: "smooth",
      }
    };
    this.comparedChartOptions = { ...this.chartOptions };
    this.sensorTypeOptions = SensorTypes;

  }

  ngOnInit(): void {
  }

  onDateRangeChange(event, compared?: string) {
    if (event.value === 'none') {
      if (compared === 'compared') {
        this.selectedComparedRange = {};
      } else {
        this.selectedRange = {};

      }
    }

    if (event.value === 'cycle-state') {
      let zoneId = compared === 'compared' ? this.selectedComparedZone._id : this.selectedZone._id
      this.zoneService.getZone(zoneId).subscribe(result => {
        let zone = result[0] as Zone
        if (compared === 'compared') {
          this.comparedStateHistoryOptions = zone.activeCycle?.stateHistory;
        } else {
          this.stateHistoryOptions = zone.activeCycle?.stateHistory;
        }
      })
    }

    if (event.value === 'cycle') {
      let zoneId = compared === 'compared' ? this.selectedComparedZone._id : this.selectedZone._id
      this.zoneService.getCycles(zoneId).subscribe(result => {
        let cycles = result.cycles.map(x => {
          return {
            state: x.name,
            dates: x.dates
          }
        })
        if (compared === 'compared') {
          this.comparedStateHistoryOptions = cycles;
        } else {
          this.stateHistoryOptions = cycles;
        }
      })
    }
  }

  fetchReport() {
    this.fetchComparedReport();
    this.isLoading = true;
    var from;
    var to;
    if (this.dateRangeOption != 'none') {
      if (this.dateRangeOption === 'custom-range') {
        // from = new Date(this.selectedRange.from);
        // from = new Date(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())).getTime();
        from = new Date(this.selectedRange.from).getTime();

        to = new Date(this.selectedRange.to);
        // to = new Date(Date.UTC(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59)).getTime();
        to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59).getTime();

      } else {
        from = Date.parse(this.selectedState.dates.start)
        // to = Date.parse(this.selectedState.dates.end || new Date().toISOString())
        to = Date.parse(this.selectedState.dates.end || new Date())

      }
    }

    let request = {
      zoneId: this.selectedZone._id,
      type: this.selectedTypes || undefined,
      from: from,
      to: to,
    }
    this.zoneService.reports(request).subscribe(result => {
      this.isLoading = false
      this.currentReport = result.report
      this.updateChart(result.report, this.chartOptions)
    })
  }

  fetchComparedReport() {
    if (!this.shouldCompare) return;
    this.isLoading = true;
    var from;
    var to;
    if (this.comparedDateRangeOption != 'none') {
      if (this.comparedDateRangeOption === 'custom-range') {
        // from = new Date(this.selectedComparedRange.from);
        //from = new Date(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())).getTime();
        from = new Date(this.selectedComparedRange.from).getTime();
        to = new Date(this.selectedComparedRange.to);
        // to = new Date(Date.UTC(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59)).getTime();
        to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59).getTime();

      } else {
        from = Date.parse(this.selectedComparedState.dates.start)
        //to = Date.parse(this.selectedComparedState.dates.end || new Date().toISOString())
        to = Date.parse(this.selectedComparedState.dates.end || new Date().toISOString())
      }
    }

    let request = {
      zoneId: this.selectedComparedZone._id,
      type: this.selectedComparedTypes || undefined,
      from: from,
      to: to,
    }
    this.zoneService.reports(request).subscribe(result => {
      this.isLoading = false;
      this.updateChart(result.report, this.comparedChartOptions);
    })
  }

  updateChart(result: any, chartOption: Partial<ChartOptions>) {
    if (result.length === 0) return;

    let fromDate = moment.utc(new Date(this.selectedRange.from)).format("YYYY-MM-DDTHH:00:00.000Z");
    fromDate = fromDate.slice(0,23).concat('Z')
    let toDate = this.selectedRange.to === this.selectedRange.from ? moment(this.selectedRange.to).format("YYYY-MM-DDT23:55:00.000Z"): moment(this.selectedRange.to).format("YYYY-MM-DDT23:30:00.000Z");
    toDate = moment.utc(new Date(toDate)).format("YYYY-MM-DDTHH:mm:00.000Z");
    toDate = toDate.slice(0,23).concat('Z')
    this.currentInverval = this.selectedRange.from == this.selectedRange.to ? 5 : 30
    this.startDate = this.selectedRange.from
    this.endDate = this.selectedRange.to

    let values = result;
    let temp = values.filter(x => x.avgValue != null)
      .reduce((acc, item) => {
        let obj = { value: +item.avgValue?.toFixed(2), date: item._id.date }
        let index = acc.findIndex(x => x.name === item._id.type);
        if (index > -1) {
          acc[index].values.push(obj);
        } else {
          acc.push({ name: item._id.type, values: [obj], start: fromDate, end: toDate, inteval: this.currentInverval  })
        }
        return acc;
      }, [])

    // console.log(temp)

    // console.log('from')
    // console.log(temp[0].values[temp[0].values.length-1].date)
    // console.log(fromDate)

    // console.log('to')
    // console.log(temp[0].values[0].date)
    // console.log(toDate)

    if(temp[0].values[0].date !== toDate){
      // console.log('push first')
      temp[0].values.unshift({value: 0, date: toDate})
    }
    if(temp[0].values[temp[0].values.length-1].date !== fromDate){
      // console.log('push last')
      temp[0].values.push({value: 0, date: fromDate})
    }
    // console.log(this.selectedRange)
    // console.log(this.selectedState)
    
    temp.forEach(x => x.values.reverse());
    let series: ApexAxisChartSeries = temp.map(x => {
      return {
        name: x.name,
        //type: "area",
        data: x.values.map(v => [new Date(v.date).getTime(), v.value])
        //data: x.values.map(v => v.value)
      }
    })
    chartOption.series = series

    switch (series.length) {
      case 1:
        chartOption.stroke.width = 6;
        break;
      case 2:
        chartOption.stroke.width = 5;
        break;
      case 3:
        chartOption.stroke.width = 4;
        break;
      case 4:
        chartOption.stroke.width = 3;
        break;
      case 5:
        chartOption.stroke.width = 2;
        break;
      default:
          chartOption.stroke.width = 1;   
    }
    
    let xAxis: ApexXAxis = {
      // categories: temp[0].values.map(x => this.datePipe.transform(x.date, 'dd-MM-yyyy HH:mm')),
      type: 'datetime',
      // min: new Date(new Date(temp[0].values[0].date).getTime() - new Date().getTimezoneOffset() * 60000).getTime(),
      // min: Date.parse(temp[0].values[0].date),
      //min: new Date(temp[0].values[0].date).getTime() - new Date().getTimezoneOffset() * 60000,
      tickAmount: 6,
      // min: new Date(temp[0].values[0].date).getTime()
      labels: {
        datetimeUTC: false
      }
    }
    chartOption.xaxis = xAxis;
    let yAxis = temp.map((x, index) => {
      let color = this.chartOptions.colors[index % this.chartOptions.colors.length]
      return {
        axisTicks: {
          show: true
        },
        axisBorder: {
          show: true,
          color: color
        },
        labels: {
          style: {
            colors: color
          }
        },
        title: {
          text: this.sensorDisplayName.transform(x.name),
          style: {
            color: color,
            fontSize: 14
          }
        },
        tooltip: {
          enabled: true
        }
      }
    })
    chartOption.yaxis = yAxis;
  }

  exportToCSV() {
    this.isLoading = true;
    var from;
    var to;
    if (this.dateRangeOption != 'none') {
      if (this.dateRangeOption === 'custom-range') {
        // from = new Date(this.selectedRange.from);
        // from = new Date(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())).getTime();
        from = new Date(this.selectedRange.from).getTime();

        to = new Date(this.selectedRange.to);
        // to = new Date(Date.UTC(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59)).getTime();
        to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59).getTime();

      } else {
        from = Date.parse(this.selectedState.dates.start)
        // to = Date.parse(this.selectedState.dates.end || new Date().toISOString())
        to = Date.parse(this.selectedState.dates.end || new Date())

      }
    }

    let request = {
      zoneId: this.selectedZone._id,
      type: this.selectedTypes || undefined,
      from: from,
      to: to,
    }
    this.zoneService.csvExport(request).subscribe(result => {
      this.isLoading = false
      const blob = new Blob([result], { type: 'type/octet-stream' });
      FileSaver.saveAs(blob, 'csv-export.csv');
    })
  }

  getZones(): void {
    this.zoneService.zones().subscribe((response: Zone[]) => {

        this.zones = response;
        let listOfZones = this.zones.map(x => {
            return { _id: x._id, name: x.name }
        })

        this.zoneList = listOfZones

        localStorage.setItem('zoneList', JSON.stringify(listOfZones));

        this.zones.forEach(zone => {
            zone.reducedSensors = Sensor.breakdownSensors(zone.sensors, zone.alerts);
            zone.alertSensors = Sensor.reduceSensorAlerts(zone.sensors, zone.alerts);
            zone.alertAppliances = Sensor.reduceApplianceAlerts(zone.sensors, zone.alerts, ['status']);

            zone.sensors.forEach(sensor => sensor.zone = zone._id);
        })

        // this.dataService.zones = this.zones;
    }, (err) => {
        switch (err.status) {
            case 401:
                //   this._logger.info('Incorrect');
                break;
        }
    }, () => {
        //   this._logger.info('Completed')
    });
  }

  zoomIn(){
    // console.log('zoom in')
    // console.log(this.chartOptions.series)

    // console.log(this.startDate)
    // console.log(this.endDate)
    // console.log(this.currentInverval)
    // let nextInterval = this.currentInverval
    // let fetchNewData = nextInterval === this.currentInverval ? false : true
    // if(fetchNewData){
    //   this.fetchReport()
    // }else{
    //   this.updateChart(this.currentReport, this.comparedChartOptions);
    // }
    
  }

  zoomOut(){
    // console.log('zoom out')
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
